
import Vue from "vue";
import filters from '@/filters';
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { Action, State } from "vuex-class";

import VueImageCropUpload from "vue-image-crop-upload";
import { data2blob, language } from "@/functions/imagecrop.function";
import { WebinarSubscriptionPricingModel } from "@/models/webinar.model";
import { webinarSubscriptionDurationType } from "@/constants/enum.constant";

@Component({
  components: {
    VueImageCropUpload,
  },
  filters,
})
export default class ModalWebinarSubscribe extends Vue {
  /* VUEX */

  /* ACTION */
  @Action("actionUploadSubscriptionPaymentProof", {namespace: "webinar"})
  private actionUploadSubscriptionPaymentProof: any;
  @Action("actionGetSubscriptionInfo", {namespace: "webinar"})
  private actionGetSubscriptionInfo: any;
  @Action("actionGetSubscriptionPricing", {namespace: "webinar"})
  private actionGetSubscriptionPricing: any;

  /* STATE */
  @State("locale")
  private locale: any;
  @State("school", {namespace: "academy"})
  private school: any;
  @State("webinar_subscription_pricing", {namespace: "webinar"})
  private webinar_subscription_pricing: Array<WebinarSubscriptionPricingModel>;

  @Watch("locale")
  private onLocaleChange() {
    const inputRefs = this.$refs.fileReceiptInput as any;
    if (inputRefs) {
      (this.$refs.fileReceiptInput as any).lang = this.languageCropImage[this.locale];
    }
  }

  @Prop({default: false})
  private isShow: boolean;

  /* INITIALIZATION */
  private pricingDetailId = 0;
  private paymentProof = "";
  private showUploadReceipt = false;
  private languageCropImage: any = language;

  private mounted() {
    const inputRefs = this.$refs.fileReceiptInput as any;
    if (inputRefs) {
      (this.$refs.fileReceiptInput as any).lang = this.languageCropImage[this.locale];
    }
    if (this.school.id) {
      this.actionGetSubscriptionPricing({
        params: {
          school_id: this.school.id
        }
      });
    }
  }

  private get showUploadButton() {
    if (this.paymentProof) return typeof this.paymentProof !== "string";
    return false;
  }

  /* METHODS */
  private getDurationType(duration_type: number) {
    if (duration_type === webinarSubscriptionDurationType.DAY) {
      return this.$i18n.t("day");
    } else if (duration_type === webinarSubscriptionDurationType.WEEK) {
      return this.$i18n.t("week");
    } else if (duration_type === webinarSubscriptionDurationType.MONTH) {
      return this.$i18n.t("month");
    } else if (duration_type === webinarSubscriptionDurationType.YEAR) {
      return this.$i18n.t("year");
    } else {
      return duration_type;
    }
  }

  private getImage() {
    if (typeof this.paymentProof === "string") return this.paymentProof;
    return URL.createObjectURL(this.paymentProof);
  }

  private openNewTab() {
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.href = this.getImage();
    a.target = "_blank";
    a.click();
    document.body.removeChild(a);
  }

  private reset() {
    this.pricingDetailId = 0;
    this.paymentProof = "";
    this.$emit("close");
  }

  private onUploadReceipt() {
    if (typeof this.paymentProof !== "string") {
      this.actionUploadSubscriptionPaymentProof({
        pricing_detail_id: this.pricingDetailId,
        payment_proof: this.paymentProof,
        success: () => {
          this.actionGetSubscriptionInfo({
            params: {
              school_id: this.school.id
            }
          });
          this.reset();
        },
      });
    }
  }

  private onCropSuccess(imgUrl: any) {
    const elImageCropUpload = this.$refs.fileReceiptInput as any;
    const blobFile = data2blob(imgUrl, elImageCropUpload.mime as string);
    const fileName = Date.now().toString() + "-webinar-receipt" + "." + elImageCropUpload.imgFormat;

    this.paymentProof = new File([blobFile], fileName);
    this.showUploadReceipt = false;
    elImageCropUpload.setStep(1);
  }
}
